import cacheAngularTemplate from 'cacheAngularTemplate';
import angularModule from 'Settings/angularModule/scripts/settings_module';
import template from 'Settings/angularModule/views/change_password.html';

const templateUrl = cacheAngularTemplate(angularModule, template);

angularModule.directive('changePassword', [
    '$injector',

    function factory($injector) {
        const AuthClient = $injector.get('AuthClient');
        const ngToast = $injector.get('ngToast');
        const TranslationHelper = $injector.get('TranslationHelper');
        const $rootScope = $injector.get('$rootScope');
        const safeApply = $injector.get('safeApply');

        return {
            restrict: 'E',
            templateUrl,
            scope: {
                submitText: '<',
            },
            link(scope) {
                //---------------------------
                // Initialization
                //---------------------------

                // Setup localization keys
                const translationHelper = new TranslationHelper('settings.change_password');

                //-------------------------
                // Navigation / Actions
                //-------------------------

                scope.preventSubmit = false;
                scope.form = {};

                scope.updatePassword = () => {
                    scope.preventSubmit = true;

                    AuthClient.updatePassword(scope.form)
                        .then(
                            () => {
                                scope.preventSubmit = false;

                                ngToast.create({
                                    content: translationHelper.get('password_updated'),
                                    className: 'success',
                                });
                                scope.form = {};
                                scope.changePasswordForm?.$setPristine();
                            },
                            () => {
                                scope.preventSubmit = false;
                                ngToast.create({
                                    content: translationHelper.get('try_again'),
                                    className: 'danger',
                                });
                            },
                        )
                        .finally(() => {
                            safeApply($rootScope);
                        });
                };
            },
        };
    },
]);
